
import { Payload } from "@/types/profile";

export const passcodePayloads: Payload[] = [
  // Passcode payloads
  {
    id: "passcode",
    name: "Passcode",
    description: "Configure passcode settings for devices",
    category: "Security",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "allowSimple",
        name: "Allow Simple Passcode",
        type: "boolean",
        required: true,
        default: false,
        description: "Allow simple passcodes (repeated, ascending, etc.)"
      },
      {
        id: "minLength",
        name: "Minimum Passcode Length",
        type: "number",
        required: true,
        default: 6,
        description: "Minimum number of characters for passcode"
      },
      {
        id: "maxFailedAttempts",
        name: "Maximum Failed Attempts",
        type: "number",
        required: false,
        default: 10,
        description: "Number of failed attempts before device wipe"
      }
    ]
  }
];
